import styled from "styled-components";

export const EventDescription = styled.div`
  display: inline-block;
  vertical-align: middle;
  white-space: pre-wrap;
  width: 60%;
  padding-right: 5%;
  text-align: left;
  line-height: 1.5em;
  font-size: 17px;
  font-weight: 400;

  button {
    vertical-align: middle;
  }
`;
